export const japanPhotoInformation = {
  "10-omakase-tuna": {
    description: ["Omakase at Ebisu Endou (the only sushi I ate this trip)"],
  },
  "12-pizza": {
    description: [
      "Savoy pizza, they did one with bluefin tuna but I think I prefer pepperoni",
    ],
  },
  "15-goldfish": {
    description: [
      "We went to a goldfish aquarium art gallery (?) and now I'm weirdly invested in bubble eye goldfish",
    ],
  },
  "16-friend": {
    description: ["ハイキング中、友達になった"],
  },
  "16-sulfur1": {
    description: ["Sulfur vents, it smelled pretty bad but looked pretty cool"],
  },
  "16-sulfur1": {
    description: ["Sulfur vents, it smelled pretty bad but looked pretty cool"],
  },
  "20-buddha-statues": {
    description: [
      "This town had tons of spiders and I walked through so many webs to take this picture",
    ],
  },
  "20-teemo": {
    description: ["Looks like a certain yordle"],
  },
  "22-imperial-palace-run1": {
    description: ["I can see why people enjoy running around the palace"],
  },
  "23-onigiri": {
    description: ["Waited 2.5 hours for this onigiri, I think it was worth it"],
  },
  "25-plane-bento": {
    description: ["Last meal from Japan, ate a bento on the plane"],
  },
}
